import { flow } from "./flow";

const {
  formField: {
    flowId,
    flowName,
    description,
    integration,
    // executeOnce,
    executionTimeoutDuration,
    retryOnFail,
    maximumTries,
    waitBetweenTries,
    onError,
    notes,
    displayExecutionLogs,
    returnValue
  }
} = flow;

const initialValues = {
  [flowId.name]: "",
  [flowName.name]: "",
  [description.name]: "",
  [integration.name]: "",
  // [executeOnce.name]: false,
  [executionTimeoutDuration.name]: "",
  [retryOnFail.name]: false,
  [maximumTries.name]: 3,
  [waitBetweenTries.name]: 1000,
  [onError.name]: "stop",
  [notes.name]: "",
  [displayExecutionLogs.name]: true,
  [returnValue.name]: "last_node_finishes"
};

export default initialValues;
